import React from "react";
import "./App.css";
import { ThemeProvider } from "./context/ThemeContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Ecosystem from "./components/Ecosystem";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-background text-foreground transition-colors duration-300">
        <main className="max-w-[720px] mx-auto px-6 md:px-8">
          <Header />
          <Hero />
          <About />
          <Ecosystem />
          <Contact />
        </main>
      </div>
    </ThemeProvider>
  );
}

export default App;